import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import docsIconUrl from "../../../assets/img/docs-icon.svg";
import { userStore } from "../../../stores/userStore";
import { sendCounterEvent } from "../../../utils/counterService";

import "./DocsButton.css";

export const DocsButton = observer(function DocsButton() {
  const { t } = useTranslation();
  const docsUrl = userStore.isRuRegion
    ? "https://docs.nextgis.ru/"
    : "https://docs.nextgis.com/";

  return (
    <Tooltip title={t("header.docsTooltip")}>
      <a
        className="app-header__docs-btn"
        href={docsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => sendCounterEvent("header_docs")}
      >
        <img src={docsIconUrl} width={20} height={20} alt="Docs" />
      </a>
    </Tooltip>
  );
});
